import {guid} from '@ultradent/utilities/Guid';
import Icon from '@components/common/Icon';

const DistributorLine = ( props ) =>
    <div key={props.sysId || guid()}
         data-testid="DistributorLine"
         className="md:flex pt-4 pb-2 md:pt-12 md:pb-8 border-b border-solid border-grey-lighter">
        <div className="flex-none w-48 mr-4 mb-4">
            {props.logo &&
                <picture>
                    <source type="image/webp" data-srcset={`${props.logo.source}?w=170&fm=webp`}/>
                    <source data-srcset={`${props.logo.source}?w=170`}/>
                    <img
                        className="lazyload w-auto fade-up"
                        data-src={`${props.logo.source}?w=170`}
                        alt={props.title}/>
                </picture>
            }
        </div>
        <div>
            <h4 className="headline-xs mb-2">{props.title || 'Unknown'}</h4>
            {props.address &&
                <address className="mb-3 leading-tight" dangerouslySetInnerHTML={{__html: props.address}}/>
            }
            {props.url &&
                <a className="flex items-center mb-3" href={props.url} target="_blank">
                <Icon.ui center name="www" className="text-lg mr-1"/> {props.url}
            </a>
            }
            {props.phone &&
                <a className="flex items-center mb-3" href={`tel:${props.phone}`}>
                <Icon.ui center name="phone" className="text-lg mr-1"/> {props.phone}
            </a>
            }
            {props.fax &&
                <a className="flex items-center mb-3" href={`tel:${props.fax}`}>
                <Icon.ui center name="fax" className="text-lg mr-1"/> {props.fax}
            </a>
            }
            {props.email &&
                <a className="flex items-center mb-3" href={`mailto:${props.email}`}>
                <Icon.ui center name="email" className="text-lg mr-1"/> {props.email}
            </a>
            }
        </div>
    </div>;

export default DistributorLine;